var React = require('react');

function BringFront (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224 0H32A32 32 0 0 0 0 32v192a32 32 0 0 0 32 32h128v-64H64V64h128v34.74A47.92 47.92 0 0 1 208 96h48V32a32 32 0 0 0-32-32zm384 256H480v64h96v128H448v-34.74a47.92 47.92 0 0 1-16 2.74h-48v64a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32V288a32 32 0 0 0-32-32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M480 144v224a48 48 0 0 1-48 48H208a48 48 0 0 1-48-48V144a48 48 0 0 1 48-48h224a48 48 0 0 1 48 48z","className":"fa-primary","key":2})]);
}

BringFront.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = BringFront;

BringFront.default = BringFront;
